import { RotateCcw } from "lucide-react";

const STATUS_STYLES = {
  delivered: "text-emerald-400 border-emerald-400/30",
  retrying: "text-amber-300 border-amber-300/30",
  pending: "text-amber-300 border-amber-300/30",
  exhausted: "text-red-400 border-red-400/30",
};

export default function DeliveryLog({ deliveries, onReplay }) {
  if (!deliveries) {
    return (
      <p className="mt-3 text-xs text-ivory/50">
        Run a step above — every webhook attempt lands here, with retries.
      </p>
    );
  }
  if (!deliveries.length) {
    return (
      <p className="mt-3 text-xs text-ivory/50" data-testid="dev-deliveries-empty">
        No deliveries yet. Register a webhook (step 2), then create a search or a watch.
      </p>
    );
  }
  return (
    <div className="mt-3 max-h-80 space-y-2 overflow-auto pr-1" data-testid="dev-delivery-log">
      {deliveries.map((d) => (
        <div
          key={d.id}
          className="flex items-center justify-between gap-3 rounded-md border border-white/10 bg-black/30 px-3 py-2.5 font-mono text-[11px]"
          data-testid="dev-delivery-row"
        >
          <div className="min-w-0">
            <p className="flex items-center gap-2">
              <span className="rounded bg-white/10 px-1.5 py-0.5 text-ivory/80">{d.event_type}</span>
              <span className={`rounded border px-1.5 py-0.5 ${STATUS_STYLES[d.status] || "text-ivory/60 border-white/20"}`}>
                {d.status}
              </span>
            </p>
            <p className="mt-1 truncate text-ivory/50">
              attempt {d.attempts}/4 ·{" "}
              {d.last_status_code ? `HTTP ${d.last_status_code}` : d.last_error || "queued"} ·{" "}
              {String(d.created_at).slice(0, 19).replace("T", " ")} UTC
            </p>
          </div>
          {d.status !== "delivered" && d.status !== "pending" && (
            <button
              onClick={() => onReplay(d.id)}
              data-testid="dev-delivery-replay"
              aria-label={`Replay delivery ${d.id}`}
              className="shrink-0 rounded border border-white/20 px-2 py-1 text-ivory/70 transition-colors hover:border-crimson hover:text-ivory"
            >
              <RotateCcw size={11} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
